export default __webpack_public_path__ + "static/my_chrome-48a1f290031ae73e711372b0188383a6.png";